import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, useParams, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import axios from "axios";
// import { axiosIns } from '../../utils'
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";

//Import actions
import { getHistoriques as onGetHistoriques } from "../../../store/actions";

//redux
import TableContainer from "../../../Components/Common/TableContainer";
import { useSelector, useDispatch } from "react-redux";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";

const HistoriqueActivity = (props) => {
  const User_id = useParams("user_id");
  // console.log("User_id: ",User_id);

  const history = useHistory();
  const dispatch = useDispatch();
  const token = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).accessToken
    : null;
  const { historiques, isHistoriqueCreated, isHistoriqueSuccess, error } =
    useSelector((state) => ({
      historiques: state.Historique.historiques,
      isHistoriqueCreated: state.Historique.isHistoriqueCreated,
      isHistoriqueSuccess: state.Historique.isHistoriqueSuccess,
      error: state.Historique.error,
    }));

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }
  //get all historique
  // useEffect( () =>
  // {
  //   axios.get( "https://stepnode.inawo.pro/" )
  // }, [] );

  const [isEdit, setIsEdit] = useState(false);
  const [historique, setHistorique] = useState([]);

  //delete Conatct
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modal, setModal] = useState(false);
  const [isExportCSV, setIsExportCSV] = useState(false);

  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);

  function handleClick() {
    forceUpdate();
  }

  // Node API
  useEffect(() => {
    if (!isHistoriqueSuccess) {
      dispatch(onGetHistoriques());
      // console.log( `token= Bearer ${ token }` );
    }
  }, [isHistoriqueSuccess, dispatch]);

  useEffect(() => {
    let activity = historiques.data;
    // console.log("activity: ", activity);

    if (activity && activity.length > 0) {
      activity = activity.filter((act) => act.admin_id === User_id.user_id);
    }

    // console.log("User_id.user_id: ", User_id.user_id);
    // console.log("activity: ", activity);

    setHistorique(activity);
  }, []);

  useEffect(() => {
    if (!isEmpty(historiques)) {
      setHistorique(historiques);
      setIsEdit(false);
    }
  }, []);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setHistorique(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const onClickDelete = (historique) => {
    setHistorique(historique);
    setDeleteModal(true);
  };

  // Add Data
  const handleHistoriqueClicks = () => {
    setHistorique("");
    setIsEdit(false);
    toggle();
  };

  const handleaccept = (e) => {
    axiosInstance
      .put(`/historiqueetat/?id=${e}`, {
        etat: "Activer",
      })
      .then((res) => {
        // console.log(res);
        toast.success("Historique activé avec succès");
        dispatch(onGetHistoriques());
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de l'activation du historique");
      });
  };

  const handlerefuse = (id_historique) => {
    axiosInstance
      .put(`/historiqueetat/?id=${id_historique}`, {
        etat: "Desactiver",
      })
      .then((res) => {
        // console.log(res);
        toast.success("Historique désactivé avec succès");
        dispatch(onGetHistoriques());
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de la désactivation du historique");
      });
  };

  // const handleValidDate = date => {
  //   const date1 = moment(new Date(date)).format("DD MMM Y");
  //   return date1;
  // };

  // const handleValidTime = (time) => {
  //   const time1 = new Date(time);
  //   const getHour = time1.getUTCHours();
  //   const getMin = time1.getUTCMinutes();
  //   const getTime = `${getHour}:${getMin}`;
  //   var meridiem = "";
  //   if (getHour >= 12) {
  //     meridiem = "PM";
  //   } else {
  //     meridiem = "AM";
  //   }
  //   const updateTime = moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
  //   return updateTime;
  // };

  // Checked All
  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".historiqueCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: props.t("Admin id"),
        accessor: "admin_id",
        filterable: false,
        Cell: (cellProps) => {
          return <span>#{cellProps.row.original.admin_id}</span>;
        },
      },
      {
        Header: props.t("Last Name"),
        accessor: "last_name",
        filterable: false,
      },
      {
        Header: props.t("First Name"),
        accessor: "first_name",
        filterable: false,
      },
      {
        Header: props.t("Email"),
        accessor: "email",
        filterable: false,
      },
      {
        Header: props.t("Action effectuée"),
        accessor: "action",
        filterable: true,
      },
      {
        Header: props.t("Table affectée"),
        accessor: "table_name",
        filterable: true,
      },
      {
        Header: props.t("Ligne touchée"),
        accessor: "record_id",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <span style={{ color: "#014c94" }}>
              #{cellProps.row.original.record_id}
            </span>
          );
        },
      },
      {
        Header: props.t("Date"),
        accessor: "action_time",
        filterable: false,
        Cell: (cellProps) => {
          return formatDate(cellProps.row.original.action_time);
        },
      },
    ],
    [toggle, props]
  );

  // SideBar Historique Deatail
  const [info, setInfo] = useState([]);

  document.title = props.t("Historiques | Takci");
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={props.t("Historiques des activités")}
            pageTitle="Takci"
            pageTitleLink="/admin"
          />
          <Row>
            {isHistoriqueSuccess && historique && historique.length > 0 && (
              <Col lg={12}>
                <Card>
                  <CardHeader>
                    <div className="d-flex justify-content-end align-items-center">
                      {/* <h2>{props.t("Customers List")}</h2> */}
                      <div className="flex-shrink-0">
                        <button
                          disabled={
                            !isHistoriqueSuccess &&
                            historique &&
                            historique.length < 0
                          }
                          type="button"
                          className="btn"
                          style={{ color: "#eac22f" }}
                          onClick={() => setIsExportCSV(true)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                          {props.t("Export")}
                        </button>
                      </div>
                    </div>{" "}
                  </CardHeader>
                </Card>
              </Col>
            )}
            <Col xxl={12}>
              <Card id="historiqueList">
                <CardBody className="pt-0">
                  <div>
                    {isHistoriqueSuccess ? (
                      historique && historique.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={isExportCSV}
                            onCloseClick={() => setIsExportCSV(false)}
                            data={
                              isHistoriqueSuccess &&
                              historique &&
                              historique.length > 0
                                ? historique
                                : []
                            }
                          />

                          <TableContainer
                            columns={columns}
                            data={
                              isHistoriqueSuccess &&
                              historique &&
                              historique.length > 0
                                ? historique
                                : []
                            }
                            isGlobalFilter={true}
                            isAddUserList={false}
                            customPageSize={8}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleAdminClick={handleHistoriqueClicks}
                            isAdminsFilter={
                              !(historique && historique.length > 0)
                            }
                          />
                        </>
                      ) : (
                        <Col
                          lg="12"
                          className="p-4 border-top border-top-dashed text-center"
                        >
                          <h6 className="text-muted text-uppercase fw-semibold mb-4">
                            Aucun Historique disponible
                          </h6>
                        </Col>
                      )
                    ) : (
                      <>
                        <div className="text-center my-3">
                          <Loader style={{ color: "#014c94" }} />
                          <h2>Chargement...</h2>
                        </div>
                      </>
                    )}
                  </div>

                  {/* <div>
                    {
                      // (isHistoriqueSuccess && historique.length > 0) 
                      // ? 
                      // (
                      //   <TableContainer
                      //     columns={columns}
                      //     data={(historique.data || [])}
                      //     isGlobalFilter={true}
                      //     isAddUserList={false}
                      //     customPageSize={8}
                      //     className="custom-header-css"
                      //     divClass="table-responsive table-card mb-3"
                      //     tableClass="align-middle table-nowrap"
                      //     theadClass="table-light"
                      //     handleHistoriqueClick={handleHistoriqueClicks}
                      //   />
                      // ) 
                      // : 
                      ( <TableContainer
                        columns={ columns }
                        data={ ( [] ) }
                        isGlobalFilter={ true }
                        isAddUserList={ false }
                        customPageSize={ 8 }
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-3"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                        handleHistoriqueClick={ handleHistoriqueClicks }
                        isHistoriquesFilter={ true }
                      /> )
                    }
                  </div> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

HistoriqueActivity.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(HistoriqueActivity));
